<script>
	let deadline = new Date(Date.UTC(2022,4,1,5,0,0));
	let now = new Date();

	let timeDifference;
	$: timeDifference = deadline - now;

	let deadlinePassed;
	$: deadlinePassed = now >= deadline;

	function days(ms) {
		return Math.floor(ms/(1000*60*60*24));
	}

	function hours(ms) {
		return Math.floor((ms%(1000*60*60*24))/(1000*60*60));
	}

	function minutes(ms) {
		return Math.floor((ms%(1000*60*60))/(1000*60));
	}

	function seconds(ms) {
		return Math.floor((ms%(1000*60))/1000);
	}

	setInterval(() => { now = new Date(); }, 500);
</script>

<main>
	{#if !deadlinePassed}
		<div class="countdown">
			<span class="text">Det är</span>
			<span class="number">{days(timeDifference)}</span>
			<span class="text">dagar, </span>
			<span class="number">{hours(timeDifference)}</span>
			<span class="text">timmar, </span>
			<span class="number">{minutes(timeDifference)}</span>
			<span class="text">minuter och</span>
			<span class="number">{seconds(timeDifference)}</span>
			<span class="text">sekunder kvar till INK!</span>
		</div>
	{:else}
		<h1>It's here!</h1>
	{/if}
</main>

<style>
	main {
		margin: 0 auto;
		padding-top: 3em;
	}

	h1 {
		font-size: 3em;
		font-weight: 700;
	}
	
	.countdown {
	}

	.number {
		font-size: 3em;
		font-weight: 700;
	}

	.text {
		font-size: 2em;
	}

	@media (max-width: 999px) {
		.countdown {
			display: flex;
			flex-wrap: nowrap;
			flex-direction: column;
			align-items: center;
			gap: 0.2em;
		}
	}

	@media (min-width: 1000px) {
		.number {
			margin: 0.2em;
		}
		.countdown {
			text-align: center;
		}
		span {
			vertical-align: middle;
		}
	}
</style>